import React, { useState} from 'react'
import './Navbar.css'
import { NavLink } from 'react-router-dom'
import logo from '../../assets/images/logo.png'

const Navbar = () => {
    const [showMenuIcon, setShowMenuIcon] = useState(false)
    const [showMenu, setShowMenu] = useState('')

    const removeMenu = () => {
        setShowMenuIcon(true)
        setShowMenu('show')
    }
    const hideMenu = () => {
        setShowMenuIcon(false);
        setShowMenu('')
    }


    return (
        <div className={`nav-main-container`} >
            <div className="py-2 px-5 acount-container" >
                <h6>
                    <label className='phone-label' htmlFor="">Call Us : +91 97600 11544 </label> 
                    <label className='email-label'>Email : oreuslife@gmail.com</label> 
                 </h6>

            </div>

            <div className="container-fluid ">
                <div className="row py-lg-3">
                    <div className="col-xl-2 ">
                        <div className="row ">
                            <div className="col-10">
                                <img className='img-fluid' src={logo} alt="" />

                            </div>
                            <div className="col-2 text-end">
                                <div className="menu-icon">
                                    {showMenuIcon ? <i className="bi bi-x-lg" onClick={hideMenu}></i> : <i className="bi bi-list " onClick={removeMenu}></i>}
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="col-xl-10 d-flex align-items-center">
                        <nav className={`navbar-container ${showMenu}`}>
                            <NavLink to='/our-products' className="link" onClick={hideMenu} >Our Products</NavLink>
                            <NavLink to='/' className="link" onClick={hideMenu}>Home</NavLink>
                            <NavLink to='/services' className="link" onClick={hideMenu}>Services</NavLink>
                            <NavLink to='/oprating-areas' className="link" onClick={hideMenu} >Area's Where We Operate</NavLink>
                            <NavLink to='/our-expertise' className="link" onClick={hideMenu} >Our Expertise</NavLink>
                            <NavLink to='/industry-focus' className="link" onClick={hideMenu} >Industry Focus</NavLink>
                            <NavLink to='/why-choose-us' className="link" onClick={hideMenu} >Why Choose Us</NavLink>
                            <NavLink to='/about-us' className="link" onClick={hideMenu}>About us</NavLink>
                            <NavLink to='/contact-us' className="link" onClick={hideMenu}>Contact us</NavLink>

                        </nav>

                    </div>
                </div>

            </div>
        </div>
    )
}

export default Navbar
